import { UIDiv } from '@ui';

export default class Loader extends UIDiv {
  constructor(
    className = 'spinner w-10 h-10 border-4 border-t-4 rounded-full animate-spin border-t-[#3486eb] border-[#f3f3f3]',
    noBackground = false,
  ) {
    super();

    // Set up loader styles
    this.setStyle('width', ['100%']);
    this.setStyle('height', ['100%']);
    this.setStyle('display', ['flex']);
    this.setStyle('justify-content', ['center']);
    this.setStyle('align-items', ['center']);
    if (!noBackground) {
      this.setStyle('background', ['#fff']);
    }

    // Create spinner element
    this.spinner = new UIDiv();
    this.spinner.setClass(className);

    this.add(this.spinner);
  }

  show() {
    this.setStyle('display', ['flex']);
  }

  hide() {
    this.setStyle('display', ['none']);
  }
}
